import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import UpdateMileage from '../UpdateMileage';
import { AdditionalServicesActionCreator, FrameworkActionCreator, AppointmentActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    selectedVehicle: state.Appointment.ApptVeh,
    MCReturned: state.AdditionalServices.maintContractData.MCReturned,
    MCError: state.AdditionalServices.maintContractData.MCError,
    waitOnMC: state.Framework.waitOnMC,
    prevMileage: state.Vehicles.selectedVehicle !== 'AddVehicle' &&
        state.Vehicles.selectedVehicle !== '' && state.Vehicles && state.Vehicles.vehicles[state.Vehicles.selectedVehicle!] ?
        state.Vehicles.vehicles[state.Vehicles.selectedVehicle!].prevMileage : 0,
    TMNAMileage: state.AdditionalServices.maintContractData.TMNAMileage,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    locale: state.Framework.locale,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    countryCode: state.Framework.dealerCountry,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
    idkMileage: state.Framework.idkMileage,
    theme: state.Framework.theme,
});

const mapDispatchToProps = {
    getMaintContracts: AdditionalServicesActionCreator.GetMaintContracts,
    setWaitOnMC: FrameworkActionCreator.SetWaitOnMC,
    updateVehicleMileage: AppointmentActionCreator.UpdateApptVehicleMileage,
    setIdkMileage: FrameworkActionCreator.SetIdkMileage,
    setAddVehicle: FrameworkActionCreator.SetAddVehicle,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(UpdateMileage);